export default "__VITE_PUBLIC_ASSET__8531ab6c__"